// React and React-Router imports
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";

// Context and other utility imports
import { useAuth, roles } from "context/AuthContext";
import ScrollToTop from "commons/components/ScrollToTop";
import ErrorBoundary from "commons/components/ErrorBoundary";

import NotFound from "commons/components/NotFound/NotFound";
// import ProfilePage from "pages/profile";
// import OrganizationPage from "pages/organization";

// Protected and Public Routes
import ProtectedRoute from "routes/ProtectedRoute";
import PublicOnlyRoute from "routes/PublicOnlyRoute";
import {
  adminRoutes,
  buyerRoutes,
  publicRoutes,
  sellerRoutes,
  securityRoutes,
} from "./routes";
// import { roles } from "commons/common-data";
import Layout from "Layout/Layout";

const Routes = () => {
  const { role: userRoles } = useAuth();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userRoles !== null) {
      setLoading(false);
    }
  }, [userRoles]);

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {publicRoutes?.map((routes, i) => {
            return (
              <Route
                path={routes.path}
                key={i}
                element={
                  routes.requiresLoggedOut !== false ? (
                    <PublicOnlyRoute>{routes.component}</PublicOnlyRoute>
                  ) : (
                    routes.component
                  )
                }
              />
            );
          })}

          {/* Protected Layout & Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {userRoles === roles?.ADMIN && (
              <>
                {adminRoutes?.map((routes, i) => {
                  return (
                    <Route
                      path={routes.path}
                      key={i}
                      element={routes.component}
                    />
                  );
                })}

                {/* <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="events" element={<EventsAdmin />} />
                <Route
                  path="business-activity"
                  element={<BusinessActivityAdmin />}
                />
                <Route path="event-details" element={<EventDetailsAdmin />} />
                <Route path="approvals" element={<Approvals />} />
                <Route path="users" element={<GetUsers />} />
                <Route path="announcement" element={<AnnouncementPage />} />
                <Route path="buyer-calendar" element={<AdminCalendar />} />
                <Route path="seller-calendar" element={<AdminCalendar />} />
                <Route path="/:id/edit-user" element={<EditUserPage />} />
                <Route
                  path="/:id/edit-organization"
                  element={<EditCompanyPage />}
                /> */}
              </>
            )}
            {userRoles === roles?.BUYER && (
              <>
                {buyerRoutes?.map((routes, i) => {
                  return (
                    <Route
                      path={routes.path}
                      key={i}
                      element={routes.component}
                    />
                  );
                })}
                {/* <Route index element={<DashBoardBuyer />} />
                <Route path="dashboard" element={<DashBoardBuyer />} />
                <Route path="events" element={<EventsBuyer />} />
                <Route path="contact-directory" element={<ContactsBuyer />} />
                <Route
                  path="meeting-scheduler"
                  element={<MeetingSchedulerBuyer />}
                />
                <Route
                  path="business-activity"
                  element={<BusinessActivityBuyer />}
                />
                <Route path="events" element={<EventsBuyer />} />
                <Route path="event-details" element={<EventDetailsBuyer />} /> */}
              </>
            )}
            {userRoles === roles?.SECURITY && (
              <>
                {securityRoutes?.map((routes, i) => {
                  return (
                    <Route
                      path={routes.path}
                      key={i}
                      element={routes.component}
                    />
                  );
                })}
              </>
            )}
            {userRoles === roles?.SELLER && (
              <>
                {sellerRoutes?.map((routes, i) => {
                  return (
                    <Route
                      path={routes.path}
                      key={i}
                      element={routes.component}
                    />
                  );
                })}
                {/* <Route index element={<DashBoardSeller />} />
                <Route path="dashboard" element={<DashBoardSeller />} />
                <Route path="events" element={<EventsSeller />} />
                <Route path="contact-directory" element={<ContactsSeller />} />
                <Route
                  path="meeting-scheduler"
                  element={<MeetingSchedulerSeller />}
                />
                <Route
                  path="business-activity"
                  element={<BusinessActivitySeller />}
                />
                <Route path="event-details" element={<EventDetailsSeller />} /> */}
              </>
            )}

            {/* <Route path="contact-directory" element={<ContactDirectory />} /> */}
            {/* <Route path="meeting-scheduler" element={<MeetingScheduler />} /> */}

            {/* <Route path="profile" element={<ProfilePage />} /> */}
            {/* <Route path="organization" element={<OrganizationPage />} /> */}
          </Route>

          {/* Fallback */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
